module.exports = __webpack_public_path__ + "static/Group_7-ffea4da408029764e6ebf5cdb92c0d5c.png";